import React, { useMemo } from 'react';
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import { Chart } from 'react-chartjs-2';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as V4ThemeProvider, createTheme as createV4Theme } from '@material-ui/core/styles';

import validate from 'validate.js';

import { chartjs } from './helpers';
import theme from './theme';
import { createTheme as createV2Theme, defaultConfig as defaultV2Config } from './theme_v2';
import useV2ThemeSettings from './theme_v2/use-theme-settings';
import palette from './theme/palette';
import typography from './theme/typography';

import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';

import validators from './common/validators';
import StoreContainer from './config/StoreContainer';
import Toast from './views/Toast';
import Loader from './views/Loader';
import history from './history';
import { isLogin } from './utils';

// 🔥 ROTAS
import Routes from './routes'; // V1
import RoutesV2 from './routes/v2.routes'; // V2

const AuthHomeRedirect = () => (
  <Redirect to={isLogin() ? '/v2/nsirs' : '/v2/login'} />
);

// 🔧 MUI V4 CONFIG
const v4Overrides = (theme.components && theme.components.v4Overrides) || {};
const v4Props = (theme.components && theme.components.v4Props) || {};

const v4Theme = createV4Theme({
  palette,
  typography,
  overrides: v4Overrides,
  props: v4Props
});

// 📊 ChartJS override
Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});

// ✅ Validators
validate.validators = {
  ...validate.validators,
  ...validators
};

function App() {
  const { modeSetting, resolvedMode, setModeSetting } = useV2ThemeSettings();
  const themeV2 = useMemo(
    () => createV2Theme({
      ...defaultV2Config,
      paletteMode: resolvedMode,
    }),
    [resolvedMode]
  );

  return (
    <ThemeProvider theme={theme}>
      <V4ThemeProvider theme={v4Theme}>
        <StoreContainer>
          <Loader />
          <Toast />

          {/* 🔥 CORRETO */}
          <Router history={history}>
            <Switch>
              
              {/* ===================== */}
              {/* Redirects para V2    */}
              {/* ===================== */}
              <Route exact path="/" component={AuthHomeRedirect} />
              <Route exact path="/login" component={AuthHomeRedirect} />

              {/* ===================== */}
              {/* 🚀 NOVO SISTEMA (V2) */}
              {/* ===================== */}
              <Route
                path="/v2"
                render={routeProps => (
                  <ThemeProvider theme={themeV2}>
                    <CssBaseline />
                    <RoutesV2
                      {...routeProps}
                      modeSetting={modeSetting}
                      resolvedMode={resolvedMode}
                      onModeSettingChange={setModeSetting}
                    />
                  </ThemeProvider>
                )}
              />
              {/* ===================== */}
              {/* 🧱 SISTEMA LEGADO */}
              {/* ===================== */}
              <Route path="/" component={Routes} />

            </Switch>
          </Router>

        </StoreContainer>
      </V4ThemeProvider>
    </ThemeProvider>
  );
}

export default App;